import { createAsyncThunk } from "@reduxjs/toolkit";
import { protectedApi } from "../../app/utils/common/protectedApi";
import { APIS } from "../../app/utils/constants/apiConstant";

export const getAllTasksAPI = createAsyncThunk(
    "task/getAllTasksAPI",
    async (_, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `/api/task/all`,
                method: "GET",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error?.response?.data?.error ?? error);
        }
    }
);

export const getTasksByDateRangeAPI = createAsyncThunk(
    "task/getTasksByDateRangeAPI",
    async ({ startDate, endDate, id }, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `/api/task/all?startDate=${startDate}&endDate=${endDate}&userId=${id}`,
                method: "GET",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const createTaskAPI = createAsyncThunk(
    "task/createTaskAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `/api/task/create`,
                method: "POST",
                data
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const getWorkingHourAPI = createAsyncThunk(
    "task/getWorkingHourAPI",
    async (date, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `/api/task/getWorkingHours?date=${date}`,
                method: "GET",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const getDailyWorkBoardCardsAPI = async ({ date, type, projectId }) => {
    const params = new URLSearchParams({ date, type });
    if (projectId != null && projectId !== "") {
        params.set("projectId", String(projectId));
    }
    const response = await protectedApi({
        url: `${APIS.TASK_BOARD_CARDS}?${params.toString()}`,
        method: "GET",
    });
    return response?.data?.data ?? [];
};

export const updateTaskAPI = createAsyncThunk(
    "task/updateTaskAPI",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `/api/task/${id}/update`,
                method: "PUT",
                data: payload
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);

export const getFilterTaskAPI = createAsyncThunk(
    "task/getFilterTaskAPI",
    async ({ userId, startDate, endDate, projectId }, { rejectWithValue }) => {
        try {
            // Build query parameters dynamically
            const queryParams = [];

            if (startDate) queryParams.push(`startDate=${startDate}`);
            if (endDate) queryParams.push(`endDate=${endDate}`);
            if (userId) queryParams.push(`userId=${userId}`);
            if (projectId) queryParams.push(`projectId=${projectId}`);

            // Join all existing parameters with '&'
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

            const response = await protectedApi({
                url: `/api/task/all${queryString}`,
                method: "GET" // Changed from PUT to GET to match other API calls
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error?.response?.data?.error ?? error);
        }
    }
);